module.exports = __webpack_public_path__ + "img/icon_alert.83ec49d5.svg";